import React, { useState } from 'react';
import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'
import {ReactComponent as SearchIcon} from '../../components/svgs/searchicon.svg';
import {ReactComponent as FilterIcon} from '../../components/svgs/filterIcon.svg';
import {ReactComponent as ExportIcon} from '../../components/svgs/exportIcon.svg';
import SalesStatusCard from './SalesStatusCard';
import StatusDropdown from '../../components/StatusDropdown';

import { Link } from 'react-router-dom';
import DropdownSVG from '../../components/OrderDropdown';

const options = [
    { label: 'Edit Order', link: '#' },
    { label: 'Duplicate Order', link: '#' },
    { label: 'Print Details', link: '#' },
    { label: 'Archive Orders', link: '#' }
  ];

  // laundry status data
const laundryStatus = [
    { label: 'All', link: '#' },
    { label: 'Binned', link: '#' },
    { label: 'Washing', link: '#' },
    { label: 'Drying', link: '#' },
    { label: 'Folding', link: '#' },
  ];


const SalesByOrderTab = () => {

    const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: 'All',
      tableData: [
        { orderNo: '#23', customer: 'Geller Industries', commercialCustomerRep: 'Ross Geller', amount: '$40.00', billingType: 'Credit Card', accountType: 'Commercial', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { orderNo: '#11', customer: 'Phoebe Buffay', amount: '$40.00', billingType: 'Cash', accountType: 'Personal', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { orderNo: '#16', customer: 'Tribianni & Sons Ltd.', commercialCustomerRep: 'Joey Tribianni', amount: '$40.00', billingType: 'Credit Card', accountType: 'Commercial', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { orderNo: '#65', customer: 'Monica’s Inc', commercialCustomerRep: 'Monica’s Geller-Bing', amount: '$40.00', billingType: 'Cash', accountType: 'Personal', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { orderNo: '#108', customer: 'Chandler Bing', amount: '$40.00', billingType: 'Credit Card', accountType: 'Commercial', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details'},
        { orderNo: '#218', customer: 'Marcel Geller', amount: '$40.00', billingType: 'Cash', accountType: 'Personal', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details'},
      ]
    },
    {
      title: 'Personal',
      tableData: [
        // Add data for Tab 2
        { orderNo: '001', customer: 'John Doe', amount: '$40.00', billingType: 'Credit Card', accountType: 'Personal', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { orderNo: '002', customer: 'Jane Smith', amount: '$40.00', billingType: 'Credit Card', accountType: 'Commercial', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
      ]
    },
    {
      title: 'Commercial',
     
      tableData: [
        { orderNo: '001', customer: 'John Doe', amount: '$40.00', billingType: 'Credit Card', accountType: 'Personal', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { orderNo: '002', customer: 'Jane Smith', amount: '$40.00', billingType: 'Credit Card', accountType: 'Commercial', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
     
      ]
    }
  ];


  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <>
    <section className='mt-10 flex gap-10'>
        <SalesStatusCard statusTitle={'Total orders'} noOfOrdersClassName={'custom-style'} salesRevenue={'3,518'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-44" />}/>
        <SalesStatusCard statusTitle={'Completed payment'} noOfOrdersClassName={'custom-style'} salesRevenue={'2,497'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-24" />}/>
        <SalesStatusCard statusTitle={'Outstanding payment'} noOfOrdersClassName={'custom-style'} salesRevenue={'3'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-24" />}/>
    </section>

    <div className="tab-container mt-10">

        <div className="tab-titles">
        {tabs.map((tab, index) => (
            <div
            key={index}
            className={`tab-title ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
            >
           
            <div className={`tab-label invoicing-tab ${activeTab === index ? 'active' : ''}`}>{tab.title}</div>
            </div>
        ))}
        </div>

        <section className='flex search-filter-section mt-4 mb-4 ml-4'>
            <section>
                <form action="">
                <label htmlFor="" className="flex flex-col order-search-input">
                    <SearchIcon className='order-search-icon search-icon'/>
                    <input type="text" placeholder="Search" className="mt-2"/>
                </label>
                </form>
            </section>
            <section className='flex gap-10 mt-10 ml-20'>
                <div className='flex gap-4'>
                    <FilterIcon/>
                    <p className='filter-section-text'>Filter</p>

                </div>
                <div className='flex gap-4'>
                    <ExportIcon/>
                    <p className='filter-section-text'>Export as csv</p>
                    
                </div>
            </section>
        </section>    
            

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div key={index} className={`tab-pane ${activeTab === index ? 'active' : ''}`}>
            <table className="custom-table custom-order-table">

              <thead>
                <tr className='table-head'>
                  <th className=''>
                  Order No.
                    <span className="filter-icon">
                      <ActiveIcon />
                      
                    </span>
                  </th>

                  <th>
                    Amount
                    <span className="filter-icon">
                    <ActiveIcon />
                    </span>
                  </th>
                  
                  <th className=''>
                    Customer
                    <span className="filter-icon">
                    <ActiveIcon className=''/>
                    </span>
                  </th>

                  <th>
                  Account type
                    <span className="filter-icon">
                        <ActiveIcon />
                    </span>
                  </th>
                
                  <th>
                    Billing type
                    <span className="filter-icon">
                      <ActiveIcon />
                    </span>
                  </th>
                  
                  <th>
                  Payment date
                    <span className="filter-icon">
                        <ActiveIcon />
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody className='table-body'>
                {tab.tableData.map((data, dataIndex) => (
                  <tr key={dataIndex} className='table-row'>
                    <td className='table-data-1'>
                      {data.orderNo}
                      
                    </td>

                    <td className='table-data'>
                      {data.amount}
                    
                    </td>
                   
                    <td className='table-data-1'>
                      {data.customer}
                      <div className='customer-rep'>{data.commercialCustomerRep}</div>
                    </td>
                   
                    <td className='table-data'>
                      {data.accountType}
                   
                    </td>
                  
                    <td className='table-data'>
                      {data.billingType}
                    
                    </td>
                   
                    <td className='table-data'>
                      {data.paymentDate}
                   
                    </td>
                    <td>
                        <Link to={data.viewButton} className='view-btn'>View</Link>
                    </td>
                    <td>
                    <DropdownSVG options={options} className="my-dropdown" />
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default SalesByOrderTab